{
  "%1$s/%2$s": "%1$s/%2$s",
  "%d%s": "%d%s",
  "%d℃": "%d℃",
  "%d℉": "%d℉",
  "%s %,.2f": "%s %,.2f",
  "%s %.2f": "%s %.2f",
  "%s %s": "%s %s",
  "%s - %s": "%s - %s",
  "%s - %s | %s": "%s - %s | %s",
  "%s, %s": "%s, %s",
  "%s, %s, %s": "%s, %s, %s",
  "%s, %s, %s, %s": "%s, %s, %s, %s",
  "(Excluding your carry-on baggage)": "(Excluding your carry-on baggage)",
  "(Optional)": "(Optional)",
  "+ %s %,.2f": "+ %s %,.2f",
  "+ Add New Address": "+ Add New Address",
  "+ New Address": "+ New Address",
  "AD": "Andorra",
  "AE": "United Arab Emirates",
  "AF": "Afghanistan",
  "AG": "Antigua and Barbuda",
  "AGE_REQUIREMENT": "You must be at least {{requiredAge}} years old to create an account.",
  "AI": "Anguilla",
  "AL": "Albania",
  "AM": "Armenia",
  "AO": "Angola",
  "AQ": "Antarctica",
  "AR": "Argentina",
  "AS": "American Samoa",
  "AT": "Austria",
  "AU": "Australia",
  "AW": "Aruba",
  "AZ": "Azerbaijan",
  "Active": "Active",
  "Analytics": "Analytics",
  "Active bookings": "Active bookings",
  "Add": "Add",
  "Add Address": "Add Address",
  "Add Bag": "Add Bag",
  "Add Bag Details": "Add Bag Details",
  "Add Bags": "Add Bags",
  "Add Bags Details Later": "Add Bags Details Later",
  "Add E-Ticket Number or Booking Reference Number": "Add E-Ticket Number or Booking Reference Number",
  "Add E-Ticket Number or Booking Reference Number *": "Add E-Ticket Number or Booking Reference Number *",
  "Add address": "Add address",
  "Add new address": "Add new address",
  "Add your dropoff location": "Add your dropoff location",
  "Add your pickup location": "Add your pickup location",
  "Added Bags": "Added Bags",
  "Address Added": "Address Added",
  "Address Added Successfully": "Address Added Successfully",
  "Address Book": "Address Book",
  "Address Name": "Address Name",
  "Address Updated Successfully": "Address Updated Successfully",
  "Address Type": "Address Type",
  "Address type": "Address type",
  "Agent Name": "Agent Name",
  "Airline logo": "Airline logo",
  "Airport": "Airport",
  "Airport To Door": "Airport To Door",
  "Airport-To-Door - Arrival Service": "Airport-To-Door - Arrival Service",
  "Actions": "Actions",
  "All": "All",
  "All Bookings": "All Bookings",
  "Almost there! this step is really important": "Almost there! this step is really important",
  "Almost there…": "Almost there…",
  "Amount": "Amount",
  "Amount due": "Amount due",
  "Amount To Be Paid:": "Amount To Be Paid:",
  "Amount:": "Amount:",
  "An OTP has been sent to": "An OTP has been sent to",
  "Anything else you would like us to know?": "Anything else you would like us to know?",
  "Apartment": "Apartment",
  "Apartment Name or Number": "Apartment Name or Number",
  "Arabic": "Arabic",
  "Are you sure you want to cancel this booking?": "Are you sure you want to cancel this booking?",
  "Are you sure you want to change your booking service?": "Are you sure you want to change your booking service?",
  "Are you sure you want to delete the following address?": "Are you sure you want to delete the following address?",
  "Are you sure you want to end booking process?": "Are you sure you want to end booking process?",
  "Additional Baggage": "Additional Baggage",
  "Additional amount": "Additional amount",
  "Additional bags": "Additional bags",
  "Additional baggage was not added": "Additional baggage was not added",
  "Area": "Area",
  "Area:": "Area:",
  "Arrival Airport": "Arrival Airport",
  "At Airport": "At Airport",
  "At Checkout": "At Checkout",
  "Attention! The flow will be ended, you will loose all the information added": "Attention! The flow will be ended, you will loose all the information added",
  "BA": "Bosnia and Herzegovina",
  "BACK": "BACK",
  "BB": "Barbados",
  "BD": "Bangladesh",
  "BE": "Belgium",
  "BF": "Burkina Faso",
  "BG": "Bulgaria",
  "BH": "Bahrain",
  "BI": "Burundi",
  "BJ": "Benin",
  "BL": "Saint Barthelemy",
  "BM": "Bermuda",
  "BN": "Brunei Darussalam",
  "BO": "Bolivia",
  "BOOKING ID=": "BOOKING ID=",
  "BR": "Brazil",
  "BS": "Bahamas",
  "BT": "Bhutan",
  "BV": "Bouvet Island",
  "BW": "Botswana",
  "BY": "Belarus",
  "BZ": "Belize",
  "Back": "Back",
  "Back to booking": "Back to booking",
  "Bag": "Bag",
  "BAG": "BAG",
  "Bag ID": "Bag ID",
  "Bag ID:": "Bag ID:",
  "Baggage Details": "Baggage Details",
  "Baggage-Info-Breakdown": "Baggage information will be shown depending on the status of the booking",
  "Extra-Bags-Payment-Confirmed": "Some bags may have been added during pickup after payment confirmation.",
  "Baggage added successfully": "Baggage added successfully",
  "Your booking has been updated to include the additional baggage.": "Your booking has been updated to include the additional baggage.",
  "Baggage changes are unavailable as your selected pickup slot is coming up.": "Baggage changes are unavailable as your selected pickup slot is coming up.",
  "Baggage updated": "Baggage updated",
  "Bags": "Bags",
  "Bags added successfully": "Bags added successfully",
  "Bags after update": "Bags after update",
  "Bar code:": "Bar code:",
  "Barcode:": "Barcode:",
  "Barcode should be 10 to 15 characters long.": "Barcode should be 10 to 15 characters long.",
  "Could not save the bag. Please try again.": "Could not save the bag. Please try again.",
  "This bag tag is already used.": "This bag tag is already used.",
  "barcode_numeric_length_error": "Barcode should be numeric and contain between 10 and 15 digits.",
  "Base Price": "Base Price",
  "Base Price:": "Base Price:",
  "Birth Date": "Birth Date",
  "Birth Date is required": "Birth Date is required",
  "Book Services": "Book Services",
  "Book a service": "Book a service",
  "Booking": "Booking",
  "Booking Created Successfully": "Booking Created Successfully",
  "Booking Details": "Booking Details",
  "Booking ID": "Booking ID",
  "Booking ID:": "Booking ID:",
  "Booking QR code": "Booking QR code",
  "Booking Summary": "Booking Summary",
  "Booking Tracking": "Booking Tracking",
  "Booking Type": "Booking Type",
  "Booking Update": "Booking Update",
  "Booking Updated Successfully": "Booking Updated Successfully",
  "Booking confirmed successfully": "Booking confirmed successfully",
  "Booking has been cancelled successfully!": "Booking has been cancelled successfully!",
  "Booking has been changed successfully!": "Booking has been changed successfully!",
  "Booking service has been changed successfully!": "Booking service has been changed successfully!",
  "Booking/Left Behind ID": "Booking/Left Behind ID",
  "Bookings": "Bookings",
  "Building": "Building",
  "Building:": "Building:",
  "Business": "Business",
  "CA": "Canada",
  "CANCEL": "CANCEL",
  "CC": "Cocos (Keeling) Islands",
  "CD": "Congo, Democratic Republic",
  "CF": "Central African Republic",
  "CG": "Congo",
  "CH": "Switzerland",
  "CI": "Cote D'Ivoire",
  "CK": "Cook Islands",
  "CL": "Chile",
  "CM": "Cameroon",
  "CN": "China",
  "CO": "Colombia",
  "CONFIRM OPTION": "CONFIRM OPTION",
  "CONTINUE WITH BOOKING": "CONTINUE WITH BOOKING",
  "CR": "Costa Rica",
  "Credits": "Credits",
  "CU": "Cuba",
  "CV": "Cape Verde",
  "CX": "Christmas Island",
  "CY": "Cyprus",
  "CZ": "Czech Republic",
  "Call support": "Call support",
  "Cancel": "Cancel",
  "Cancel Booking": "Cancel Booking",
  "Cancel Booking?": "Cancel Booking?",
  "Cancelled": "Cancelled",
  "Card Holder Name": "Card Holder Name",
  "Card Holder Name:": "Card Holder Name:",
  "Card Number": "Card Number",
  "Card Number:": "Card Number:",
  "Change": "Change",
  "Change Language": "Change Language",
  "Change Language To:": "Change Language To:",
  "Change Payment Method": "Change Payment Method",
  "Change Service": "Change Service",
  "Change address": "Change address",
  "Change service is not possible for this booking type": "Change service is not possible for this booking type",
  "Check-out Desk": "Check-out Desk",
  "Checked In": "Checked In",
  "Checked-in bags": "Checked-in bags",
  "Choose your preferred language": "Choose your preferred language",
  "City": "City",
  "City:": "City:",
  "Class": "Class",
  "Close": "Close",
  "Coming to pickup": "Coming to pickup",
  "Complete your baggage service booking for your": "Complete your baggage service booking for your",
  "Completed": "Completed",
  "Confirm": "Confirm",
  "Confirm Option": "Confirm Option",
  "Confirm Booking": "Confirm Booking",
  "Confirm Booking Creation": "Confirm Booking Creation",
  "Confirm Password": "Confirm Password",
  "Confirm drop-off location": "Confirm drop-off location",
  "Confirm password is required": "Confirm password is required",
  "Confirm removal": "Confirm removal",
  "Confirm_Booking_Creation_Details": "Please confirm if you would like to continue creating the booking with the details provided. Click back, if you want to re-check.",
  "Confirmed": "Confirmed",
  "Contact": "Contact",
  "Contact #": "Contact Number",
  "Contact Artaah Support": "Contact {{ appName }} Support",
  "Contact Support": "Contact Support",
  "Choose a Baggage Service": "Choose a Baggage Service",
  "Contact Us": "Contact Us",
  "Continue": "Continue",
  "Continue with New Booking": "Continue with New Booking",
  "Continue to payment": "Continue to payment",
  "Current bags": "Current bags",
  "Copy": "Copy",
  "Count": "Count",
  "Country Code": "Country Code",
  "Create Booking": "Create Booking",
  "Customer Name": "Customer Name",
  "Customer Signature": "Customer Signature",
  "D to D delivery breakdown": "Just like that, from your home door to your door at your destination, don’t fret, carry, load or unload! We get your luggage and you served so you travel easy and light.",
  "DE": "Germany",
  "DJ": "Djibouti",
  "DK": "Denmark",
  "DM": "Dominica",
  "DO": "Dominican Republic",
  "DZ": "Algeria",
  "Dashboard": "Dashboard",
  "Date": "Date",
  "Date of Birth": "Date of Birth",
  "Debit/Credit Card": "Debit/Credit Card",
  "Delete": "Delete",
  "Delete Account": "Delete Account",
  "Delete Address": "Delete Address",
  "Delete Photo": "Delete Photo",
  "Deliver to my address": "Deliver to my address",
  "Delivered": "Delivered",
  "Delivering": "Delivering",
  "Delivering to customer": "Delivering to customer",
  "Delivering to you": "Delivering to you",
  "Delivery Method": "Delivery Method",
  "Departure Airport": "Departure Airport",
  "Didn't get it?": "Didn't get it?",
  "Didn't receive the OTP yet?": "Didn't receive the OTP yet?",
  "Discount": "Discount",
  "Discount:": "Discount:",
  "Dismiss": "Dismiss",
  "Done": "Done",
  "Don't Contact the customer": "Don't Contact the customer",
  "Don’t have an account?": "Don’t have an account?",
  "Door To Airport": "Door To Airport",
  "Door To Door": "Door To Door",
  "Door to door luggage delivery": "Door to door luggage delivery",
  "Door-Check-in-Service-Breakdown": "Get your luggage picked up from your place and delivered at your destination hassle free",
  "Door-To-Door": "Door-To-Door",
  "Door-to-Airport - Departure Service": "Door-to-Airport - Departure Service",
  "Driver Arrived": "Driver Arrived",
  "Driver Details": "Driver Details",
  "Driver details will appear here once the booking is assigned": "Driver details will appear here once the booking is assigned",
  "Driver name": "Driver name",
  "Driver phone": "Driver phone",
  "Driver phone is not available": "Driver phone is not available",
  "Details": "Details",
  "Driver Tracking Ended": "Driver Tracking Ended",
  "Drop-off Address": "Drop-off Address",
  "Drop-off Details": "Drop-off Details",
  "Drop-off Location": "Drop-off Location",
  "Drop-off location": "Drop-off location",
  "Drop-off Slot": "Drop-off Slot",
  "Drop-off slot": "Drop-off slot",
  "Drop-off Time": "Drop-off Time",
  "Drop-off slot has been updated successfully!": "Drop-off slot has been updated successfully!",
  "Dropoff": "Dropoff",
  "Dropoff Location": "Dropoff Location",
  "Dropoff location": "Dropoff location",
  "Dropoff:": "Dropoff:",
  "Dropped To Arrival Desk": "Dropped To Arrival Desk",
  "Dropped To Departure Desk": "Dropped To Departure Desk",
  "Dropping to Airport": "Dropping to Airport",
  "E-Ticket Number or Booking Reference Number": "E-Ticket Number or Booking Reference Number",
  "e.g. ABCD1234": "e.g. ABCD1234",
  "E.g. SV1234": "E.g. SV1234",
  "EC": "Ecuador",
  "EE": "Estonia",
  "EG": "Egypt",
  "EH": "Western Sahara",
  "EID - By card reader": "EID - By card reader",
  "EID Picture (Front and Back)": "EID Picture (Front and Back)",
  "END BOOKING PROCESS": "END BOOKING PROCESS",
  "ER": "Eritrea",
  "ES": "Spain",
  "EST DELIVERY TIME :": "EST DELIVERY TIME :",
  "ET": "Ethiopia",
  "ETA": "ETA",
  "ETA Duration": "ETA Duration",
  "Economy": "Economy",
  "Edit": "Edit",
  "Edit Address": "Edit Address",
  "Edit number of bags": "Edit number of bags",
  "Edit Drop-off Slot": "Edit Drop-off Slot",
  "Edit Pickup Slot": "Edit Pickup Slot",
  "Email": "Email",
  "Email / Phone Number": "Email / Phone Number",
  "Email Address": "Email Address",
  "Email is required": "Email is required",
  "Email or Phone Number": "Email or Phone Number",
  "Email support": "Email support",
  "Empty-DropOff-Desc-Message": "Sorry to inform you that there are no drop-off slots available for the provided information. Slots availability depends on the Flight Arrival Date and Time and selected Pickup or Drop-off locations",
  "Empty-Pickup-Desc-Message": "Sorry to inform you that there are no pickup slots available for the provided information. Slots availability depends on the Flight Departure Date and Time and selected Pickup or Drop-off locations",
  "Bookings-Paused-Title": "All new bookings are temporarily paused.",
  "Bookings-Paused-Description": "We're not accepting new reservations at the moment, but this may change soon. Please check back later for updates and availability.",
  "Bookings-Paused-Tagline": "Your next journey could be just one click away.",
  "English": "English",
  "National_Address_Hint": "Entering your National Address does not automatically update the map location.",
  "Enter Bag ID": "Enter Bag ID",
  "Enter Flight Date (Optional)": "Enter Flight Date (Optional)",
  "Enter OTP to Access Your Booking": "Enter OTP to Access Your Booking",
  "Enter Your": "Enter Your",
  "Enter Your Phone Number": "Enter Your Phone Number",
  "Enter flight code (E.g. SV1234)": "Enter flight code (E.g. SV1234)",
  "Enter passenger email address": "Enter passenger email address",
  "Enter passenger first name": "Enter passenger first name",
  "Enter passenger last name": "Enter passenger last name",
  "Enter the 6-digit code": "Enter the 6-digit code",
  "Enter the OTP": "Enter the OTP",
  "Enter the code we sent to you": "Enter the code we sent to you",
  "Error": "Error",
  "Ex. drop with the security...": "Ex. drop with the security...",
  "Experience. Seamless. Travelling": "Experience. Seamless. Travelling",
  "Experience. Seamless. Travelling breakdown": "Travel after #artaah has changed and will never be the same again, use the world’s most advanced, convenient and globally unique service for travel.",
  "Expired": "Expired",
  "FAQs": "FAQs",
  "FI": "Finland",
  "FJ": "Fiji",
  "FK": "Falkland Islands (Malvinas)",
  "FM": "Micronesia, Federated States of",
  "FO": "Faroe Islands",
  "FR": "France",
  "Failed": "Failed",
  "Failed Delivery": "Failed Delivery",
  "Failed to deliver": "Failed to deliver",
  "Female": "Female",
  "File size must not exceed 10 MB.": "File size must not exceed 10 MB.",
  "Fill in the address details below": "Fill in the address details below",
  "First": "First",
  "First Name": "First Name",
  "First Name is required": "First Name is required",
  "First name is required": "First name is required",
  "Flight Code": "Flight Code",
  "Flight Code:": "Flight Code:",
  "Flight Details": "Flight Details",
  "Flight Number": "Flight Number",
  "Flight Not Found": "Flight Not Found",
  "Flight code": "Flight code",
  "Floor": "Floor",
  "Floor Number": "Floor Number",
  "Floor Number(Optional)": "Floor Number(Optional)",
  "Floor:": "Floor:",
  "Forgot Password?": "Forgot Password?",
  "GA": "Gabon",
  "GB": "United Kingdom",
  "GD": "Grenada",
  "GE": "Georgia",
  "GF": "French Guiana",
  "GG": "Guernsey",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GL": "Greenland",
  "GM": "Gambia",
  "GMT": "GMT",
  "GN": "Guinea",
  "GO BACK": "GO BACK",
  "GP": "Guadeloupe",
  "GQ": "Equatorial Guinea",
  "GR": "Greece",
  "GS": "South Georgia and the South Sandwich Islands",
  "GT": "Guatemala",
  "GU": "Guam",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "Gender": "Gender",
  "Get Flight Details": "Get Flight Details",
  "Get In Touch": "Get In Touch",
  "Knowledge Base": "Knowledge Base",
  "Go Back": "Go Back",
  "HIGHLY SATISFIED": "HIGHLY SATISFIED",
  "HK": "Hong Kong",
  "HM": "Heard Island & Mcdonald Islands",
  "HN": "Honduras",
  "HR": "Croatia",
  "HT": "Haiti",
  "HU": "Hungary",
  "Have an account already?": "Have an account already?",
  "Haven’t Received the code yet?": "Haven’t Received the code yet?",
  "Hi": "Hi",
  "Hint:": "Hint:",
  "Home": "Home",
  "How can we do better in the next times? (Optional)": "How can we do better in the next times? (Optional)",
  "How was your booking?": "How was your booking?",
  "How would you like to pay?": "How would you like to pay?",
  "I accept": "I accept",
  "I confirm that the information provided is accurate to the best of my knowledge. I understand that {{ appName }} and the airline are not responsible for discrepancies resulting from inaccurate or incomplete information provided during booking.": "I confirm that the information provided is accurate to the best of my knowledge. I understand that {{ appName }} and the airline are not responsible for discrepancies resulting from inaccurate or incomplete information provided during booking.",
  "It’s time to pay": "It’s time to pay",
  "I want to pay later": "I want to pay later",
  "I will pick it myself": "I will pick it myself",
  "ID": "Indonesia",
  "IE": "Ireland",
  "IL": "Israel",
  "IM": "Isle of Man",
  "IMPORTANT!": "IMPORTANT!",
  "IN": "India",
  "IO": "British Indian Ocean Territory",
  "IQ": "Iraq",
  "IR": "Iran, Islamic Republic of",
  "IS": "Iceland",
  "IT": "Italy",
  "Identification": "Identification",
  "Identification Number": "Identification Number",
  "Identification Type": "Identification Type",
  "In Airport Pickup": "In Airport Pickup",
  "In Flight": "In Flight",
  "In Pickup": "In Pickup",
  "In Transit": "In Transit",
  "Incorrect OTP code.": "Incorrect OTP code.",
  "Invalid E-Ticket Number. Please ensure it contains only digits": "Invalid E-Ticket Number. Please ensure it contains only digits",
  "Invalid E-ticket number or Booking Reference": "Invalid E-ticket number or Booking Reference",
  "Invalid Value": "Invalid Value",
  "Invalid format, please make sure the file format is in .png, .jpg, or .jpeg": "Invalid format, please make sure the file format is in .png, .jpg, or .jpeg",
  "Invoice": "Invoice",
  "Invoices": "Invoices",
  "JE": "Jersey",
  "JM": "Jamaica",
  "JO": "Jordan",
  "JP": "Japan",
  "KE": "Kenya",
  "KG": "Kyrgyzstan",
  "KH": "Cambodia",
  "KI": "Kiribati",
  "KM": "Comoros",
  "KN": "Saint Kitts and Nevis",
  "KP": "Korea (Democratic People's Republic of)",
  "KR": "Korea, Republic of",
  "KW": "Kuwait",
  "KY": "Cayman Islands",
  "KZ": "Kazakhstan",
  "Kg": "Kg",
  "LA": "Lao People's Democratic Republic",
  "LB": "Lebanon",
  "LC": "Saint Lucia",
  "LI": "Liechtenstein",
  "LK": "Sri Lanka",
  "LR": "Liberia",
  "LS": "Lesotho",
  "LT": "Lithuania",
  "LU": "Luxembourg",
  "LUGGAGE IS HERE!": "LUGGAGE IS HERE!",
  "LUGGAGE-ARRIVAL-INSTRUCTIONS-KEY": "{{ appName }} agent just arrived at your doorstep, Please meet him to receive your luggage",
  "LV": "Latvia",
  "LY": "Libya",
  "Last Name": "Last Name",
  "Last Name is required": "Last Name is required",
  "Last name is required": "Last name is required",
  "Latitude": "Latitude",
  "Let us know how was your experience of booking with Artaah?": "Let us know how was your experience of booking with {{ appName }}?",
  "Let's add your checked-in bags": "Let's add your checked-in bags",
  "Let's add your dropoff location": "Let's add your dropoff location",
  "Let's add your pickup location": "Let's add your pickup location",
  "Let's retrieve flight details": "Let's retrieve flight details",
  "Let's verify it's you": "Let's verify it's you",
  "Lets have a last look at your booking": "Lets have a last look at your booking",
  "Link Expired:": "Link Expired:",
  "Live Location": "Live Location",
  "Login": "Login",
  "Login your account": "Login your account",
  "Logout": "Logout",
  "Log Out": "Log Out",
  "Longitude": "Longitude",
  "Luggage": "Luggage",
  "Luggage Checkin": "Luggage Checkin",
  "Luggage Checkout": "Luggage Checkout",
  "Luggage Delivery": "Luggage Delivery",
  "Luggage Live Location": "Luggage Live Location",
  "Luggage Pickup": "Luggage Pickup",
  "Luggage Transit": "Luggage Transit",
  "MA": "Morocco",
  "MC": "Monaco",
  "MD": "Moldova",
  "ME": "Montenegro",
  "MF": "Saint Martin",
  "MG": "Madagascar",
  "MH": "Marshall Islands",
  "MK": "Macedonia",
  "ML": "Mali",
  "MM": "Myanmar",
  "MM/DD/YYYY (e.g., 04/28/1990)": "MM/DD/YYYY (e.g., 04/28/1990)",
  "MN": "Mongolia",
  "MO": "Macao",
  "MP": "Northern Mariana Islands",
  "MQ": "Martinique",
  "MR": "Mauritania",
  "MS": "Montserrat",
  "MT": "Malta",
  "MU": "Mauritius",
  "MV": "Maldives",
  "MW": "Malawi",
  "MX": "Mexico",
  "MY": "Malaysia",
  "MZ": "Mozambique",
  "Make sure picture is clear": "Make sure picture is clear",
  "Male": "Male",
  "My Profile": "My Profile",
  "Name": "Name",
  "N/A": "N/A",
  "NA": "Namibia",
  "NC": "New Caledonia",
  "NE": "Niger",
  "NF": "Norfolk Island",
  "NG": "Nigeria",
  "NI": "Nicaragua",
  "NL": "Netherlands",
  "NO": "Norway",
  "NORMAL": "NORMAL",
  "NOT GOOD": "NOT GOOD",
  "NP": "Nepal",
  "NR": "Nauru",
  "NU": "Niue",
  "NZ": "New Zealand",
  "Name cannot exceed 30 characters.": "Name cannot exceed 30 characters.",
  "National Address": "National Address",
  "National Address Code": "National Address Code",
  "National Address:": "National Address:",
  "Nationality": "Nationality",
  "New": "New",
  "New Booking": "New Booking",
  "New slot is held. Complete payment before it expires.": "New slot is held. Complete payment before it expires.",
  "Next": "Next",
  "No FAQs available": "No FAQs available",
  "No addresses added yet": "No addresses added yet",
  "No payment pending for this booking": "No payment pending for this booking",
  "No payment required": "No payment required",
  "No drop-off slots are available. Please try again later.": "No drop-off slots are available. Please try again later.",
  "No pickup slots are available. Please try again later.": "No pickup slots are available. Please try again later.",
  "No slots available": "No slots available",
  "No time slots are currently available. You may cancel or try again later.": "No time slots are currently available. You may cancel or try again later.",
  "No time slots are currently available for this booking. You may cancel this booking or try again later.": "No time slots are currently available for this booking. You may cancel this booking or try again later.",
  "Note": "Note",
  "Note cannot exceed 255 characters.": "Note cannot exceed 255 characters.",
  "Note cannot exceed 500 characters.": "Note cannot exceed 500 characters.",
  "Note: Please check your ticket to know your baggage allowance, the airline might charge you for any extra weight": "Note: Please check your ticket to know your baggage allowance, the airline might charge you for any extra weight",
  "No. of bags": "No. of bags",
  "Notes": "Notes",
  "Number of Bags": "Number of Bags",
  "OK": "Ok",
  "OM": "Oman",
  "ON THE WAY FOR DROPOFF": "ON THE WAY FOR DROPOFF",
  "OTP": "OTP",
  "OTP code is incorrect.": "OTP code is incorrect.",
  "OTP send": "OTP send",
  "OTP will be sent to the selected number": "OTP will be sent to the selected number",
  "OTP-instructions": "You have a delivery pending regarding your luggage from {{ appName }}.",
  "OTP-instructions-2": "Lets add your details so it can be delivered ASAP.",
  "OTP-instructions-3": "we need to verify your phone first",
  "verify-otp-phone-subtitle": "We'll send a one-time code to {{ phone }}.",
  "verify-otp-privacy-note": "This keeps your booking and delivery address private, visible only to you and {{ appName }}.",
  "verify-id-title": "Enter your {{ idType }}",
  "verify-id-subtitle": "We use this to confirm your identity before releasing your bag.",
  "verify-id-placeholder": "e.g. 192278507",
  "verify-bags-subtitle-singular": "Your left-behind bag from {{ organization }} is ready to be scheduled.",
  "verify-bags-subtitle-plural": "Your left-behind bags from {{ organization }} are ready to be scheduled.",
  "verify-bags-count-singular": "{{ count }} bag ready",
  "verify-bags-count-plural": "{{ count }} bags ready",
  "verify-bags-check-note": "Check each bag before continuing",
  "verify-bag-label": "Bag {{ number }}",
  "verify-bag-index": "{{ current }} of {{ total }}",
  "Delivery fee applies": "Delivery fee applies",
  "I'll pick it up myself": "I'll pick it up myself",
  "no delivery fee.": "no delivery fee.",
  "A delivery fee of": "A delivery fee of",
  "applies.": "applies.",
  "Choose a baggage delivery slot": "Choose a baggage delivery slot",
  "Building / Villa": "Building / Villa",
  "Note for the driver": "Note for the driver",
  "Gate code, landmark, or delivery instructions": "Gate code, landmark, or delivery instructions",
  "e.g. Al Olaya": "e.g. Al Olaya",
  "e.g. 12": "e.g. 12",
  "e.g. 3": "e.g. 3",
  "e.g. Villa 41": "e.g. Villa 41",
  "Off To Airport": "Off To Airport",
  "Office/Hotel": "Office/Hotel",
  "Office/Hotel Name or Number": "Office/Hotel Name or Number",
  "Ok": "Ok",
  "Optional": "Optional",
  "Other": "Other",
  "Overview": "Overview",
  "Section": "Section",
  "Out for delivery": "Out for delivery",
  "PA": "Panama",
  "PAY": "PAY",
  "PE": "Peru",
  "PF": "French Polynesia",
  "PG": "Papua New Guinea",
  "PH": "Philippines",
  "PK": "Pakistan",
  "PL": "Poland",
  "PM": "Saint Pierre and Miquelon",
  "PN": "Pitcairn",
  "PNR": "PNR",
  "POWERED BY": "POWERED BY",
  "PR": "Puerto Rico",
  "PROCEED": "PROCEED",
  "PS": "Palestine, State of",
  "PT": "Portugal",
  "PW": "Palau",
  "PY": "Paraguay",
  "Paid": "Paid",
  "Passenger Information": "Passenger Information",
  "Passenger Name": "Passenger Name",
  "Passport": "Passport",
  "Passport Number": "Passport Number",
  "Password": "Password",
  "Password is required": "Password is required",
  "Password reset successfully": "Password reset successfully",
  "Password should be 8 characters or more": "Password should be 8 characters or more",
  "Passwords do not match": "Passwords do not match",
  "Pay Later": "Pay Later",
  "Phone": "Phone",
  "Pay Now": "Pay Now",
  "Pay with Debit/Credit Card": "Pay with Debit/Credit Card",
  "Payment": "Payment",
  "Price": "Price",
  "Payment Details": "Payment Details",
  "Payment Failed": "Payment Failed",
  "Payment History": "Payment History",
  "Payment Link": "Payment Link",
  "Payment Pending": "Payment Pending",
  "Payment Status": "Payment Status",
  "Payment Summary": "Payment Summary",
  "Payment failed, please try again": "Payment failed, please try again",
  "Payment was not completed. Your original baggage quantity remains unchanged.": "Payment was not completed. Your original baggage quantity remains unchanged.",
  "Pending": "Pending",
  "Pending Booking Details": "Pending Booking Details",
  "Pending Extra Booking Details": "Pending Extra Booking Details",
  "Pending Payment": "Pending Payment",
  "Personal ID": "Personal ID",
  "Phone Number": "Phone Number",
  "Pick-up Location": "Pick-up Location",
  "Picking up from Airport": "Picking up from Airport",
  "Picking up from customer": "Picking up from customer",
  "Pickup": "Pickup",
  "Pickup Address": "Pickup Address",
  "Pickup Details": "Pickup Details",
  "Pickup Slot": "Pickup Slot",
  "Pickup Time": "Pickup Time",
  "Pickup Window": "Pickup Window",
  "Pickup slot has been updated successfully!": "Pickup slot has been updated successfully!",
  "Pickup:": "Pickup:",
  "Pickup location": "Pickup location",
  "Pictures": "Pictures",
  "Please add your bags before completing payment.": "Please add your bags before completing payment.",
  "Please add your dropoff address to continue": "Please add your dropoff address to continue",
  "Please add your pickup address to continue": "Please add your pickup address to continue",
  "Please add your reason here": "Please add your reason here",
  "Please click on ": "Please click on ",
  "Please click on the button below to confirm your details": "Please click on the button below to confirm your details",
  "Please confirm the following points to proceed with the booking": "Please confirm the following points to proceed with the booking",
  "Please enter a valid email": "Please enter a valid email",
  "Please enter a valid phone number": "Please enter a valid phone number",
  "Please enter the code you received": "Please enter the code you received",
  "Please enter the information to retrieve the flights": "Please enter the information to retrieve the flights",
  "Please enter your bag ID": "Please enter your bag ID",
  "Please enter your updated password": "Please enter your updated password",
  "Please make sure you have entered the valid information": "Please make sure you have entered the valid information",
  "Please select the slot for pick from the pickup location": "Please select the slot for pick from the pickup location",
  "Please select the slot for drop off at the dropoff location": "Please select the slot for drop off at the dropoff location",
  "Please select the slot to drop your luggage at the below location": "Please select the slot to drop your luggage at the below location",
  "Please select your preferred option to deliver your luggage": "Please select your preferred option to deliver your luggage",
  "Please confirm using OTP or your password to continue.": "Please confirm using OTP or your password to continue.",
  "Please verify your email": "Please verify your email",
  "Please verify your phone number": "Please verify your phone number",
  "Please review them before proceeding to select your baggage service.": "Please review them before proceeding to select your baggage service.",
  "We'll use your mobile number to send booking updates and provide secure access to your tracking link.": "We'll use your mobile number to send booking updates and provide secure access to your tracking link.",
  "Please wait while we prepare your baggage service options.": "Please wait while we prepare your baggage service options.",
  "Please write your email address below": "Please write your email address below",
  "Please_ensure_your_selection_matches_your_ticket": "Please ensure your selection matches your ticket.",
  "Please_enter_the_OTP_sent_to_your_registered_mobile_number/email_to_confirm": "Please enter the OTP sent to your registered mobile number/email to confirm.",
  "Preparing your Booking": "Preparing your Booking",
  "Proceed": "Proceed",
  "Proceed To Pay": "Proceed To Pay",
  "Processing": "Processing",
  "Profile Details": "Profile Details",
  "Prohibited goods": "Prohibited goods",
  "Proof Of Delivery": "Proof Of Delivery",
  "Proof Of Pickup": "Proof Of Pickup",
  "Proof Of Pickup / Delivery": "Proof Of Pickup / Delivery",
  "Province": "Province",
  "QA": "Qatar",
  "QR Code": "QR Code",
  "QR-CODE-INSTRUCTION-KEY": "You need to show this QR code to {{ appName }} representative once he arrive to dropoff your luggage",
  "RE": "Reunion",
  "RO": "Romania",
  "RS": "Serbia",
  "RU": "Russian Federation",
  "RW": "Rwanda",
  "Re-type Password": "Re-type Password",
  "Re-upload": "Re-upload",
  "Recover Password": "Recover Password",
  "Reference Key:": "Reference Key:",
  "Refund": "Refund",
  "Refund Failed": "Refund Failed",
  "Refund In Progress": "Refund In Progress",
  "Refund Method": "Refund Method",
  "Refund Succeeded": "Refund Succeeded",
  "Refunded": "Refunded",
  "Reselect Drop-off Slot": "Reselect Drop-off Slot",
  "Reselect Pickup Slot": "Reselect Pickup Slot",
  "Reselect Slot": "Reselect Slot",
  "Reselect Slots": "Reselect Slots",
  "Register": "Register",
  "Register Account": "Register Account",
  "Reload?": "Reload?",
  "Remembered your password?": "Remembered your password?",
  "Remove": "Remove",
  "Remove Bag": "Remove Bag",
  "Replace": "Replace",
  "Request OTP": "Request OTP",
  "Request OTP code to proceed with the tracking link": "Request OTP code to proceed with the tracking link",
  "Required": "Required",
  "Required formats:": "Required formats:",
  "Resend Code": "Resend Code",
  "Resend OTP": "Resend OTP",
  "Resend OTP in": "Resend OTP in",
  "Resend OTP?": "Resend OTP?",
  "Resend code": "Resend Code",
  "Reset Password": "Reset Password",
  "SA": "Saudi Arabia",
  "SAR": "SAR",
  "SATISFIED": "SATISFIED",
  "SB": "Solomon Islands",
  "SC": "Seychelles",
  "SD": "Sudan",
  "SE": "Sweden",
  "SG": "Singapore",
  "SH": "Saint Helena",
  "SI": "Slovenia",
  "SJ": "Svalbard and Jan Mayen",
  "SK": "Slovakia",
  "SL": "Sierra Leone",
  "SM": "San Marino",
  "SN": "Senegal",
  "SO": "Somalia",
  "SR": "Suriname",
  "SS": "South Sudan",
  "ST": "Sao Tome and Principe",
  "SUBMIT FEEDBACK": "SUBMIT FEEDBACK",
  "SV": "El Salvador",
  "SX": "Sint Maarten",
  "SY": "Syrian Arab Republic",
  "SZ": "Swaziland",
  "Save": "Save",
  "Save As": "Save As",
  "Save to address book": "Save to address book",
  "Scheduled": "Scheduled",
  "Search": "Search",
  "Search or Select Your Location": "Search or Select Your Location",
  "Select the bags you want to add": "Select the bags you want to add",
  "Choose a delivery slot": "Choose a delivery slot",
  "Select a payment method": "Select a payment method",
  "Select payment method": "Select payment method",
  "Select Drop-off Slot": "Select Drop-off Slot",
  "Select Drop-off Slot:": "Select Drop-off Slot:",
  "Select Dropoff Slot": "Select Dropoff Slot",
  "Select Flight": "Select Flight",
  "Select Flight Date": "Select Flight Date",
  "Select Language": "Select Language",
  "Select Payment Method": "Select Payment Method",
  "Select Phone Number": "Select Phone Number",
  "Select Pickup Slot": "Select Pickup Slot",
  "Select card type to proceed": "Select card type to proceed",
  "Select gender": "Select gender",
  "Selected Dropoff slot": "Selected Dropoff slot",
  "Selected Pickup Slot": "Selected Pickup Slot",
  "Selected Service": "Selected Service",
  "Selected time slots may fill up quickly. Availability of the selected time slot is confirmed at the time of payment.": "Selected time slots may fill up quickly. Availability of the selected time slot is confirmed at the time of payment.",
  "Slot has been updated successfully!": "Slot has been updated successfully!",
  "Slots are filling fast. Book the slot by paying soon to confirm.": "Slots are filling fast. Book the slot by paying soon to confirm.",
  "The time window has passed. Reselect a slot to continue.": "The time window has passed. Reselect a slot to continue.",
  "The slot selected is not confirmed until booking is paid": "The slot selected is not confirmed until booking is paid",
  "Send Verification Code": "Send Verification Code",
  "Send me OTP": "Send me OTP",
  "Service": "Service",
  "Status": "Status",
  "Pickup / Dropoff": "Pickup / Dropoff",
  "page_of_total": "Page {{page}} of {{total}}",
  "col_booking_id": "ID",
  "Service Type": "Service Type",
  "Service charges": "Service charges",
  "Service:": "Service:",
  "Services": "Services",
  "Share": "Share",
  "Show QR Code": "Show QR Code",
  "Show less": "Show less",
  "Show less slots": "Show less slots",
  "Show more": "Show more",
  "Show more slots": "Show more slots",
  "Sign up": "Sign up",
  "Skip": "Skip",
  "Something Went Wrong!!": "Something Went Wrong!!",
  "Something went wrong with your booking? (Optional)": "Something went wrong with your booking? (Optional)",
  "Sorry Something is not right!": "Sorry Something is not right!",
  "error_popup_title": "Something went wrong on our side",
  "error_popup_message": "This isn't your fault and nothing was saved. Trying again usually works.",
  "Stages": "Stages",
  "Status:": "Status:",
  "Submit": "Submit",
  "Success": "Success",
  "Support": "Support",
  "TC": "Turks and Caicos Islands",
  "TD": "Chad",
  "TF": "French Southern Territories",
  "TG": "Togo",
  "TH": "Thailand",
  "TJ": "Tajikistan",
  "TK": "Tokelau",
  "TL": "Timor-Leste",
  "TM": "Turkmenistan",
  "TN": "Tunisia",
  "TO": "Tonga",
  "TR": "Turkey",
  "TT": "Trinidad and Tobago",
  "TV": "Tuvalu",
  "TW": "Taiwan, Province of China",
  "TZ": "Tanzania, United Republic of",
  "Tag the Location": "Tag the Location",
  "Task": "Task",
  "Thank you for your payment": "Thank you for your payment",
  "The Experience": "The Experience",
  "The same barcode was added already, please use another barcode": "The same barcode was added already, please use another barcode",
  "There is no amount to refund for this booking.": "There is no amount to refund for this booking.",
  "This bag ID has already been added.": "This bag ID has already been added.",
  "This bag ID is already used in another booking": "This bag ID is already used in another booking",
  "Ticket Number": "Ticket Number",
  "Ticket number": "Ticket number",
  "Travel class": "Travel class",
  "Select Date": "Select Date",
  "Flight Date": "Flight Date",
  "Flight Departure": "Flight Departure",
  "Flight Arrival": "Flight Arrival",
  "Excluding your carry-on baggage": "Excluding your carry-on baggage",
  "Please place the code into the square": "Please place the code into the square",
  "Ensure the barcode is fully visible before scanning": "Ensure the barcode is fully visible before scanning",
  "flight": "flight",
  "flight_class_info_1": "{{ appName }} ensures a seamless experience for all travelers. Please select your actual class as airlines may verify this selection.",
  "flight_class_info_2": "Incorrect selections may affect your eligibility for premium services.",
  "Pickup & Drop-off": "Pickup & Drop-off",
  "Pickup & Drop-off Times": "Pickup & Drop-off Times",
  "Pickup slot": "Pickup slot",
  "Dropoff slot": "Dropoff slot",
  "Retrieve flight details": "Retrieve flight details",
  "Get Flight": "Get Flight",
  "Type of luggage delivery service you need?": "Type of luggage delivery service you need?",
  "Verify Email": "Verify Email",
  "Update password": "Update password",
  "Confirm your mobile number": "Confirm your mobile number",
  "Profile Information": "Profile Information",
  "Account Information": "Account Information",
  "Verify": "Verify",
  "Verify your location": "Verify your location",
  "Enter_your_National_Address_Alert_Box": "Select or search your location on the map, then verify that the pin matches your actual pickup location. Adjust the pin if needed before saving.",
  "Verify Phone number": "Verify Phone number",
  "Verify your phone number": "Verify your phone number",
  "Time": "Time",
  "Time remaining:": "Time remaining:",
  "Time Spent": "Time Spent",
  "Time Zone": "Time Zone",
  "To avoid confusion": "To avoid confusion, please select the same pickup slot as your previous booking.",
  "To change the language, the page will need to reload, and all unsaved changes will be lost.": "To change the language, the page will need to reload, and all unsaved changes will be lost.",
  "Together.. we are changing movement": "Together.. we are changing movement",
  "Total": "Total",
  "Total Amount": "Total Amount",
  "Total Bags": "Total Bags",
  "Total Charges": "Total Charges",
  "Total Passengers": "Total Passengers",
  "Total amount": "Total amount",
  "Total bag charges": "Total bag charges",
  "Total baggage charges": "Total baggage charges",
  "Total:": "Total:",
  "Track delivery breakdown": "We pickup your luggage, and deliver it, while you enjoy your travel",
  "Tracking": "Tracking",
  "Tracking Ended": "Tracking Ended",
  "Transaction ID": "Transaction ID",
  "Travel Bags": "Travel Bags",
  "Travel Class": "Travel Class",
  "Try Again": "Try Again",
  "Type": "Type",
  "UA": "Ukraine",
  "UG": "Uganda",
  "UM": "United States Minor Outlying Islands",
  "UNSATISFIED": "UNSATISFIED",
  "US": "United States",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "Unit": "Unit",
  "Unit Number": "Unit Number",
  "Unit Number (Optional)": "Unit Number (Optional)",
  "Unit:": "Unit:",
  "Unable to load location suggestions. Please try again.": "Unable to load location suggestions. Please try again.",
  "Unknown": "Unknown",
  "Update": "Update",
  "Update Bag": "Update Bag",
  "Update drop-off slot": "Update drop-off slot",
  "Update pickup slot": "Update pickup slot",
  "Upload Photo": "Upload Photo",
  "Upload Picture": "Upload Picture",
  "Updated total": "Updated total",
  "Use My Credits": "Use My Credits",
  "Username is required": "Username is required",
  "Username or password incorrect.": "Username or password incorrect.",
  "VA": "Holy See (Vatican City State)",
  "VAT": "VAT",
  "VAT Percentage:": "VAT ({{X}}%)",
  "VAT:": "VAT:",
  "VC": "Saint Vincent and the Grenadines",
  "VE": "Venezuela",
  "VG": "Virgin Islands, British",
  "VI": "Virgin Islands, U.S.",
  "VN": "Viet Nam",
  "VU": "Vanuatu",
  "Valid email is required": "Valid email is required",
  "Verification Code": "Verification Code",
  "Verify Code": "Verify Code",
  "Verify OTP": "Verify OTP",
  "Version": "Version",
  "View": "View",
  "View All": "View All",
  "View Booking": "View Booking",
  "View Booking Details": "View Booking Details",
  "View Details": "View Details",
  "View Existing Booking": "View Existing Booking",
  "View Invoice": "View Invoice",
  "View Invoices": "View Invoices",
  "View More": "View More",
  "View QR Code": "View QR Code",
  "View all booking details and track them": "View all booking details and track them",
  "View images": "View images",
  "View/Download": "View/Download",
  "Villa": "Villa",
  "Villa Name or Number": "Villa Name or Number",
  "WF": "Wallis and Futuna",
  "WS": "Samoa",
  "Waiting for driver to send his updates": "Waiting for driver to send his updates",
  "We Found an Existing Booking": "We Found an Existing Booking",
  "We had an issue generating your QR code": "We had an issue generating your QR code",
  "We sent you an otp to your phone number": "We sent you an otp to your phone number",
  "We're here to help you": "We're here to help you",
  "What type of luggage delivery service you need?": "What type of luggage delivery service you need?",
  "When do you want us to drop your luggage?": "When do you want us to drop your luggage?",
  "When do you want us to pickup your luggage?": "When do you want us to pickup your luggage?",
  "With baggage assistant": "With baggage assistant",
  "Work": "Work",
  "Wrong Identification Number": "Wrong {{idType}}",
  "YE": "Yemen",
  "YT": "Mayotte",
  "You are back online!": "You are back online!",
  "You are offline. Check your internet connection.": "You are offline. Check your internet connection.",
  "You don't have a booking tied to this identification number": "You don't have a booking tied to this identification number",
  "You have": "You have",
  "You have a booking pending": "You have a booking pending",
  "You have a delivery pending": "You have a delivery pending",
  "You need to bring your Identification with you": "You need to bring your Identification with you",
  "You will be notified when the booking is out for pickup": "You will be notified when the booking is out for pickup",
  "All scheduled time windows have passed. Create a new booking to continue.": "All scheduled time windows have passed. Create a new booking to continue.",
  "Your Changes Have Been Saved Successfully": "Your Changes Have Been Saved Successfully",
  "address_list_empty_hint": "Your address list is empty! Please add a new address to continue",
  "Your address has been deleted successfully": "Your address has been deleted successfully",
  "Your bag ID has been updated!": "Your bag ID has been updated!",
  "Your flight details have been securely imported from": "Your flight details have been securely imported from",
  "Your reserved slot is no longer available. Please select a new one.": "Your reserved slot is no longer available. Please select a new one.",
  "Your slot is held. Complete payment before the timer expires.": "Your slot is held. Complete payment before the timer expires.",
  "Your slot is still available. Pay now to confirm it.": "Your slot is still available. Pay now to confirm it.",
  "Your booking will be confirmed but payment will be required before service": "Your booking will be confirmed but payment will be required before service",
  "Your booking has been created successfully!": "Your booking has been created successfully!",
  "Your booking has been created. Please make the payment by clicking on the link or <b>“Pay Now”</b>": "Your booking has been created. Please make the payment by clicking on the link or <b>“Pay Now”</b>",
  "Your booking has been updated successfully!": "Your booking has been updated successfully!",
  "Your booking has been updated. Please make the payment by clicking on the link or <b>“Pay Now”</b>": "Your booking has been updated. Please make the payment by clicking on the link or <b>“Pay Now”</b>",
  "Your booking is cancelled. Please contact support for any queries.": "Your booking is cancelled. Please contact support for any queries.",
  "Your fare is calculated based on the distance from the airport and the rates agreed with the airline.": "Your fare is calculated based on the distance from the airport and the rates agreed with the airline.",
  "Your ride": "Your ride",
  "Your_boarding_pass_or_e-ticket_typically_includes_your_class": "Your boarding pass or e-ticket typically includes your class.",
  "ZA": "South Africa",
  "ZM": "Zambia",
  "ZW": "Zimbabwe",
  "account.deactivate.action": "Deactivate Account",
  "account.deactivate.description": "Your account will be deactivated and access will be disabled. You may reactivate your account at any time by logging in again.",
  "account.deactivate.success": "Your account has been deactivated successfully. To reactivate, log in using your registered credentials.",
  "account.deactivate.title": "Deactivate Account",
  "account.deactivated.loginBanner": "Your account has been deactivated.",
  "account.delete.availableAfter": "Available after",
  "account.delete.blockedTitle": "Unable to Delete Account",
  "account.delete.confirmCta": "Confirm Deletion",
  "account.delete.continue": "Continue",
  "account.delete.coolOffNotFinished": "Please wait until the cool-off period ends before confirming deletion.",
  "account.delete.goToBookings": "Go to Bookings",
  "account.delete.invalidOtp": "Invalid code. Please try again.",
  "account.delete.irreversibleDescription": "Your personal data will be permanently removed and anonymized. Booking, baggage, and payment records will be retained without personal identifiers. After confirming, a cool-off period applies before deletion is finalized. Are you sure you want to permanently delete your account?",
  "account.delete.noPendingRequest": "No deletion request found. Please start again.",
  "account.delete.pendingBanner": "Your account deletion will be available after",
  "account.delete.pendingLabel": "Pending Deletion",
  "account.delete.requested": "Your deletion request has been submitted. You will be able to confirm after the cool-off period.",
  "account.delete.success": "Your account has been permanently deleted.",
  "account.delete.title": "Confirm Account Deletion",
  "account.otp.sentTo": "We've sent a One-Time Password (OTP) to your mobile ending with",
  "account.otp.verify": "Verify & Continue",
  "account.otp.verifyIdentity": "We need to verify your identity",
  "account.phone.alreadyInUse": "This phone number is already linked to another account.",
  "account.phone.sameNumber": "New number must be different from your current phone number.",
  "account.phone.unsupportedCountryCode": "This country code is not supported. Please use a different number.",
  "account.reactivate.emailSubtitle": "Enter your email to re-activate",
  "account.reactivate.otpSentTo": "An OTP has been sent to",
  "account.reactivate.proceed": "Proceed",
  "account.reactivate.reactivateNow": "Re-activate it now",
  "account.reactivate.success": "Your account has been reactivated successfully.",
  "account.reactivate.title": "Re-activate your account",
  "account.reactivate.verify": "Verify",
  "account.reactivate.verifyTitle": "Please Verify your email",
  "already have a booking": "You already have a booking for this flight. Our team will coordinate all your bags through a single driver.",
  "and": "and",
  "bagid_hint_info_message": "This Bag ID is final and cannot be modified after saving. Please double-check before proceeding.",
  "blocking.DeleteCustomerNotEligibleActiveBooking": "Your account cannot be deleted because you have an active booking. Please complete or resolve it before requesting deletion.",
  "blocking.DeleteCustomerNotEligiblePendingRefund": "Your account cannot be deleted because you have a pending refund.",
  "blocking.DeleteCustomerNotEligibleUnpaidBooking": "Your account cannot be deleted because you have an unpaid booking.",
  "blocking.DeleteCustomerNotEligibleUpcomingBooking": "Your account cannot be deleted because you have an upcoming booking.",
  "cancel_booking_info_message": "You can cancel your booking up to 90mins before the your selected pickup/drop-off time.",
  "cs_bags_hint": "Add {{max}} bags in total. The total permitted weight will depend on your ticket's baggage allowance.",
  "cs_bag_count_hint": "Pay now to reserve delivery for {{count}} bag(s). Add bag details later.",
  "manage_bags_adding_hint": "Adding {{count}} bags. Baggage updates only after payment is completed.",
  "manage_bags_adding_hint_one": "Adding {{count}} bag. Baggage updates only after payment is completed.",
  "manage_bags_removing_hint": "Removing {{count}} bags. No refund or app credit. Cannot be undone.",
  "manage_bags_removing_hint_one": "Removing {{count}} bag. No refund or app credit. Cannot be undone.",
  "manage_bags_edit_hint": "Use – and + to change the number of bags. Available until {{hours}} hours before your pickup slot.",
  "manage_bags_updated_total_hint": "Your booking has been updated to {{count}} bags.",
  "manage_bags_updated_total_hint_one": "Your booking has been updated to {{count}} bag.",
  "bags_count": "{{count}} bags",
  "By Passenger": "By Passenger",
  "By Bag": "By Bag",
  "By PNR": "By PNR",
  "Bag Upload Progress": "Bag Upload Progress",
  "Bag Upload Complete": "Bag Upload Complete",
  "Link URL": "Link URL",
  "cm": "cm",
  "day(s)": "day(s)",
  "distance_from_airport": "{{distance}} km from {{airport_code}} airport",
  "drop-off timing change note": "Note: The drop-off slots are subject to change based on the flight status (Delay / Cancellation)",
  "drop-off-note": "This slot matches your existing booking for the same flight. Bags will be delivered together.",
  "dropoff-slot-timezone-note": "Times are shown in the local time of the drop-off service city ({{ offset }}).",
  "email": "email",
  "hour(s)": "hour(s)",
  "if you still have an issue, contact our support team": "if you still have an issue, contact our support team",
  "it should contain at least 1 lowercase character": "it should contain at least 1 lowercase character",
  "it should contain at least 1 special letter": "it should contain at least 1 special letter",
  "it should contain at least 1 uppercase character": "it should contain at least 1 uppercase character",
  "km": "km",
  "max size: 10 mb": "max size: 10 mb",
  "minute": "minute",
  "minute(s)": "minute(s)",
  "password": "password",
  "pick-up-note": "This slot matches your existing booking for the same flight. All bags will be collected together.",
  "pickup-slot-timezone-note": "Times are shown in the local time of the pickup service city ({{ offset }}).",
  "privacy policy": "privacy policy",
  "rest for the session": "rest for the session",
  "session-expires-in": "Session expires in {{ time }}",
  "second": "second",
  "second(s)": "second(s)",
  "seconds": "seconds",
  "submit the code in:": "submit the code in:",
  "terms & conditions": "terms & conditions",
  "try again": "try again",
  "unit: ": "unit: ",
  "username_hint": "Email ({{email}}) Phone (+{{phone}})",
  "Enter a valid email address": "Enter a valid email address",
  "Email or phone number is required": "Email or phone number is required",
  "Enter a valid email or phone number": "Enter a valid email or phone number",
  "it should contain at least 1 number": "it should contain at least 1 number",
  "If an account exists for this email, we've sent a verification code to it. Please enter the code below.": "If an account exists for this email, we've sent a verification code to it. Please enter the code below.",
  "verification code": "verification code",
  "view_live_location_tooltip": "You can track your driver once they’re en route to your location.",
  "year(s)": "year(s)",
  "|": "|",
  "العربية": "العربية",
  "No_Bookings_Title": "No Bookings",
  "No_Bookings_Desc": "No Bookings found for the provided filters",
  "terms_consent_prefix": "I have read and agree to the",
  "Terms and Conditions": "Terms and Conditions",
  "Terms & Conditions": "Terms & Conditions",
  "Privacy Policy": "Privacy Policy",
  "invalid_booking_reference": "Invalid booking reference. Enter a 6-character alphanumeric code or a 15-digit e-ticket number",
  "invalid_total_passengers": "Please enter a valid number of total passengers",
  "Upload your bag details": "Upload your bag details",
  "The number of bags cannot be increased after payment.": "The number of bags cannot be increased after payment.",
  "Please select the slot for pickup from your location": "Please select the slot for pickup from your location",
  "Please select the slot for pick from the drop-off location": "Please select the slot for pick from the drop-off location",
  "no_slots_available_desc": "Sorry to inform you that, there are no pickup slots available for the provided information",
  "no_dropoff_slots_available_desc": "Sorry to inform you that, there are no drop-off slots available for the provided information",
  "All transactions for this booking": "All transactions for this booking",
  "Bag Barcode": "Bag Barcode",
  "Drop-off Window": "Drop-off Window",
  "Flyplus": "Flyplus",
  "Artaah": "Artaah",
  "CHATBOT.TITLE": "Chat with AI Assistant",
  "CHATBOT.SUBTITLE": "Ask me anything about your booking",
  "CHATBOT.WELCOME_MESSAGE": "Hi! I'm your AI assistant. I can help you with:\n\n• Booking information and status\n• Pickup and delivery schedules\n• Payment details\n• Service changes\n• General inquiries\n\nHow can I assist you today?",
  "CHATBOT.PLACEHOLDER": "Type your message...",
  "CHATBOT.TYPING": "AI Assistant is typing...",
  "CHATBOT.ERROR_MESSAGE": "Connection error. Please check your internet and try again.",
  "CHATBOT.NEW_CONVERSATION": "Start New Conversation",
  "CHATBOT.HISTORY": "Conversation History",
  "CHATBOT.NO_CONVERSATIONS": "No previous conversations",
  "CHATBOT.LOADING": "Connecting to your assistant...",
  "CHATBOT.UNAVAILABLE": "The AI assistant is currently unavailable. Please try again later.",
  "CHATBOT.VALIDATION_ERROR": "Please check your message and try again.",
  "CHATBOT.NOT_FOUND_ERROR": "I could not find that information. Please check the details and try again.",
  "CHATBOT.TIMEOUT_ERROR": "The assistant is taking longer than expected. Please try again.",
  "CHATBOT.RETRY": "Retry",
  "Security Upgrade Required": "Security Upgrade Required",
  "We've upgraded Artaah authentication and account security to align with the Fly+ identity platform. As part of this update, you're required to reset your password once before continuing. Your account details, bookings, and history remain unaffected.": "We've upgraded Artaah authentication and account security to align with the Fly+ identity platform. As part of this update, you're required to reset your password once before continuing. Your account details, bookings, and history remain unaffected.",
  "If you experience any issues, please contact support.": "If you experience any issues, please contact support.",
  "Verify your email": "Verify your email",
  "We sent a verification code to": "We sent a verification code to",
  "Didn't receive the code?": "Didn't receive the code?",
  "Resend in": "Resend in",
  "Set New Password": "Set New Password",
  "Choose a strong password to secure your account.": "Choose a strong password to secure your account.",
  "New password": "New password",
  "Enter your new password": "Enter your new password",
  "Confirm password": "Confirm password",
  "Re-enter your new password": "Re-enter your new password",
  "Passwords do not match. Please re-enter your new password to confirm.": "Passwords do not match. Please re-enter your new password to confirm.",
  "Confirm Reset": "Confirm Reset",
  "Minimum 8 characters required": "Minimum 8 characters required",
  "Must include uppercase, number, and special character": "Must include uppercase, number, and special character",
  "Help Center": "Help Center",
  "Policies": "Policies",
  "Contact & Support": "Contact & Support",
  "Search FAQs": "Search FAQs",
  "Clear search": "Clear search",
  "No FAQs found": "No FAQs found",
  "Failed to load FAQs. Please try again.": "Failed to load FAQs. Please try again.",
  "No policies available": "No policies available",
  "No support channels available": "No support channels available",
  "Responds within": "Responds within",
  "Policy Details": "Policy Details",
  "Effective": "Effective",
  "On this page": "On this page",
  "current_language_name": "English",
  "Articles": "Articles",
  "No articles available": "No articles available",
  "Attachments": "Attachments",
  "No PDFs attached.": "No PDFs attached.",
  "PDF": "PDF",
  "PDFs": "PDFs",
  "Download": "Download",
  "View PDF": "View PDF",
  "Live": "Live",
  "Updating...": "Updating...",
  "Reconnecting...": "Reconnecting...",
  "Connection lost": "Connection lost",
  "Last updated {{time}}": "Last updated {{time}}",
  "Updated {{time}}": "Updated {{time}}",
  "just now": "just now",
  "{{n}}s ago": "{{n}}s ago",
  "{{n}}m ago": "{{n}}m ago",
  "Ready for pickup": "Ready for pickup",
  "You can collect your bag at the check-out desk shown below.": "You can collect your bag at the check-out desk shown below.",
  "Delivery scheduled": "Delivery scheduled",
  "We'll notify you as your bag makes its way to you.": "We'll notify you as your bag makes its way to you.",
  "Tracking page information": "Tracking page information",
  "Delivery location": "Delivery location",
  "Location confirmed": "Location confirmed",
  "Self pick-up": "Self pick-up",
  "Desk:": "Desk:",
  "Last updated": "Last updated",
  "by": "by",
  "Delivery slot": "Delivery slot",
  "Slot confirmed": "Slot confirmed",
  "No delivery slots are available right now.": "No delivery slots are available right now.",
  "Save changes": "Save changes",
  "View bag images": "View bag images",
  "Bag images": "Bag images",
  "Compare these photos with the bag before scheduling or collecting it.": "Compare these photos with the bag before scheduling or collecting it.",
  "qr_caption_self_pickup": "Show this QR code at the check-out desk if you're collecting your bag in person.",
  "qr_caption_delivery": "Show this QR code to the driver once he arrives so they can scan it and hand over your luggage.",
  "Copy tracking link": "Copy tracking link",
  "locateMe": "Locate Me",
  "Tracking link copied": "Tracking link copied",
  "Could not copy tracking link": "Could not copy tracking link",
  "EST Delivery time:": "EST Delivery time:",
  "Agency Name": "Agency Name",
  "Representative": "Representative",
  "Departure Flight": "Departure Flight",
  "Destination Address": "Destination Address",
  "Arrival Flight": "Arrival Flight",
  "Upload New Bags": "Upload New Bags",
  "Multiple people can upload bags using this same link": "Multiple people can upload bags using this same link",
  "Added All Bags": "Added All Bags",
  "Search...": "Search...",
  "Add Passengers": "Add Passengers",
  "Room": "Room",
  "Hotel Name": "Hotel Name",
  "Bag Tag / Barcode": "Bag Tag / Barcode",
  "Notes (Optional)": "Notes (Optional)",
  "No bags uploaded": "No bags uploaded",
  "No passengers added yet.": "No passengers added yet.",
  "No bags uploaded yet.": "No bags uploaded yet.",
  "Start by scanning or adding a new bag...": "Start by scanning or adding a new bag...",
  "Start by adding a new passenger...": "Start by adding a new passenger...",
  "No passengers match your search.": "No passengers match your search.",
  "No bags match your search.": "No bags match your search.",
  "Add passenger": "Add passenger",
  "Tracking Not Available": "Tracking Not Available",
  "No PNR groups found.": "No PNR groups found.",
  "{{ appName }} Booking Tracking": "{{ appName }} Booking Tracking",
  "tracking_otp_sent_title": "We’ve sent a One-Time Password (OTP).",
  "tracking_otp_enter_code_hint": "Please enter the code below to securely access your booking.",
  "tracking_otp_code_expired": "This code has expired. Please request a new one.",
  "tracking_otp_invalid": "Invalid OTP. Please check the code and try again.",
  "Upload Bag Photo": "Upload Bag Photo",
  "Drop photo here or click to upload": "Drop photo here or click to upload",
  "Choose": "Choose",
  "Passenger name": "Passenger name",
  "Enter passenger name": "Enter passenger name",
  "Hotel name": "Hotel name",
  "Enter hotel name": "Enter hotel name",
  "E.g. 10": "E.g. 10",
  "Enter area name": "Enter area name",
  "E.g. ABC123": "E.g. ABC123",
  "E.g. A12345678": "E.g. A12345678",
  "Bag Tag/Barcode": "Bag Tag/Barcode",
  "E.g. 12345678910": "E.g. 12345678910",
  "Special instructions...": "Special instructions...",
  "Scan Barcode": "Scan Barcode",
  "Add Passenger Details": "Add Passenger Details",
  "example@email.com": "example@email.com",
  "E.g. 501234567": "E.g. 501234567",
  "Hotel": "Hotel",
  "Room Number": "Room Number",
  "E.g. 911": "E.g. 911",
  "Enter area": "Enter area",
  "Add Passenger": "Add Passenger",
  "All Bags Added Successfully!": "All Bags Added Successfully!",
  "You are about to mark this booking as complete.": "You are about to mark this booking as complete.",
  "Invite Collaborator": "Invite Collaborator",
  "Invite collaborators to add bags": "Invite collaborators to add bags",
  "Send Invitation": "Send Invitation",
  "Invalid format. Use .png/.jpg/.jpeg": "Invalid format. Use .png/.jpg/.jpeg",
  "Could not read the selected photo. Please try again.": "Could not read the selected photo. Please try again.",
  "Upload failed: no URL returned": "Upload failed: no URL returned",
  "Upload failed": "Upload failed",
  "Please enter or scan the bag barcode.": "Please enter or scan the bag barcode.",
  "Error Reading Barcode! Please Try Again.": "Error Reading Barcode! Please Try Again.",
  "Delete Bag": "Delete Bag",
  "tracking-passengers-added-bags-count": "{{ completed }} of {{ total }} Passengers Added Bags",
  "tracking-bags-count": "Bags ({{ count }})",
  "tracking-bag-count-badge": "{{ count }} Bags",
  "tracking-pnr-passenger-count-singular": "{{ count }} Passenger",
  "tracking-pnr-passenger-count-plural": "{{ count }} Passengers",
  "tracking-otp-expires-in": "Expires in: {{ seconds }}s",
  "tracking-confirm-delete-bag-description": "Are you sure you want to delete bag <strong>{{ code }}</strong>? This action cannot be undone.",
  "Your booking": "Your booking",
  "Individual": "Individual",
  "Group": "Group",
  "Passenger": "Passenger",
  "Booking type": "Booking type",
  "Estimated delivery": "Estimated delivery",
  "Show QR code": "Show QR code",
  "passengers ready": "passengers ready",
  "Add your bags": "Add your bags",
  "Invite someone to help": "Invite someone to help",
  "Search by bag tag, PNR, or passenger": "Search by bag tag, PNR, or passenger",
  "Full name": "Full name",
  "Passport number": "Passport number",
  "Needs passport": "Needs passport",
  "Bag tag": "Bag tag",
  "Add a note (optional)": "Add a note (optional)",
  "tracking-booking-subtitle": "#{{ id }} · booked by {{ agency }}",
  "tracking-booking-subtitle-id-only": "#{{ id }}",
  "tracking-add-bags-subtitle": "Enter the passenger details and add a bag tag for each bag. Anyone with this link can help; changes save as you go.",
  "tracking-delivery-progress-subtitle": "{{ service }} · {{ status }}",
  "tracking_request_otp_hint": "Request OTP code to proceed with the tracking link",
  "tracking_enter_otp_button": "Enter OTP to Access Your Booking",
  "live_tracking_subtitle": "Track your driver in real time",
  "current_language_short": "En",
  "Delivery progress": "Delivery progress",
  "Flight": "Flight",
  "Selected service": "Selected service",
  "invoices_dialog_subtitle": "All invoices for this booking",
  "Ref:": "Ref:",
  "Card Holder": "Card Holder",
  "link_expired_message": "This link has expired.",
  "tracking_load_passengers_failed": "Failed to load passengers",
  "tracking_load_bags_failed": "Failed to load bags",
  "tracking_load_pnr_list_failed": "Failed to load PNR list",
  "E.g. AB1234": "E.g. AB1234",
  "slot-no-longer-available": "The selected slot is no longer available. Please choose another slot.",
  "camera_access_required_title": "Camera access required",
  "camera_access_required_message": "Allow camera access to scan the baggage barcode.",
  "camera_access_blocked_hint": "If camera access is blocked, enable it from your browser’s site permissions, then try again.",
  "Enable Camera": "Enable Camera",
  "Camera unavailable": "Camera unavailable",
  "camera_unavailable_message": "We couldn’t start a camera on this device. Please enter the barcode manually.",
  "pnr_format_error": "PNR must be exactly 6 characters, using only letters (A–Z) and numbers (0–9), with no spaces or special characters.",
  "PNR is required": "PNR is required",
  "recover_password_instruction": "Enter your registered email address or phone number.",
  "Email or phone number": "Email or phone number",
  "Email or phone number is required": "Email or phone number is required",
  "invalid_email_or_phone": "Please enter a valid email address or phone number.",
  "Terms and Conditions are not available yet": "Terms and Conditions are not available yet",
  "We couldn't load the Terms and Conditions": "We couldn't load the Terms and Conditions",
  "Retry": "Retry",
  "recover_password_code_sent": "If an account exists for this email or phone number, we've sent a verification code to it. Please enter the code below.",
  "id_number_letters_digits_only": "Use letters and numbers only, up to 20 characters",
  "National Address Code is required": "National Address Code is required",
  "national_address_format_error": "Use 4 letters followed by 4 numbers (e.g. ABCD1234)",
  "ID:": "ID:"
}
